import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useDocumentReportsInfiniteQueryKey } from './useDocumentReportsInfiniteQueryKey'

export const useInvalidateDocumentReportsInfiniteQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useDocumentReportsInfiniteQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
